
import  { useEffect } from 'react'
import i18n from '../i18n'

export const useLanguage = () => {
  const presetlanguage = window.localStorage.getItem('lang')
  console.log('language is present in the local storage',presetlanguage)
  useEffect(() => {
    if (presetlanguage) {
      console.log('language is present in the local storage so changing it to',presetlanguage)
      i18n.changeLanguage(presetlanguage)
    } else {
      let lang = 'en'
      if (navigator.language.includes('tr')) {
        lang = 'tr'
      }
      window.localStorage.setItem('lang', lang)
     
    }
  }, [])
  return null
}